import { createReducer, on } from '@ngrx/store';
import { ISharedFolderContentResponse, IUnreadResponse } from '../../models';
import { IActionState, ActionStateCreator } from '../../utils/state-utils';
import * as fromActions from './shared-content.actions';

export interface ISharedContentState {
  sharedContentActionState: IActionState;
  sharedContent: ISharedFolderContentResponse;
  unreadActionState: IActionState;
  unread: IUnreadResponse;
  migrateDocumentsActionState: IActionState;
}

export const initialState: ISharedContentState = {
  sharedContentActionState: ActionStateCreator.create(),
  sharedContent: null,
  unreadActionState: ActionStateCreator.create(),
  unread: null,
  migrateDocumentsActionState: ActionStateCreator.create(),
};

export const sharedContentReducer = createReducer(
  initialState,

  on(fromActions.GetSharedContent, state => {
    return {
      ...state,
      sharedContentActionState: ActionStateCreator.onStart(),
    };
  }),
  on(fromActions.GetSharedContentSuccess, (state, { response }) => {
    return {
      ...state,
      sharedContentActionState: ActionStateCreator.onSuccess(),
      sharedContent: response,
    };
  }),
  on(fromActions.GetSharedContentFailed, (state, { error }) => {
    return {
      ...state,
      sharedContentActionState: ActionStateCreator.onError(error),
      sharedContent: null,
    };
  }),

  on(fromActions.GetUnread, state => {
    return {
      ...state,
      unreadActionState: ActionStateCreator.onStart(),
    };
  }),
  on(fromActions.GetUnreadSuccess, (state, { response }) => {
    return {
      ...state,
      unreadActionState: ActionStateCreator.onSuccess(),
      unread: response,
    };
  }),
  on(fromActions.GetUnreadFailed, (state, { error }) => {
    return {
      ...state,
      unreadActionState: ActionStateCreator.onError(error),
      unread: null,
    };
  }),

  on(fromActions.MigrateDocuments, state => {
    return {
      ...state,
      migrateDocumentsActionState: ActionStateCreator.onStart(),
    };
  }),
  on(fromActions.MigrateDocumentsSuccess, state => {
    return {
      ...state,
      migrateDocumentsActionState: ActionStateCreator.onSuccess(),
    };
  }),
  on(fromActions.MigrateDocumentsFailed, (state, { error }) => {
    return {
      ...state,
      migrateDocumentsActionState: ActionStateCreator.onError(error),
    };
  })
);

export const getSharedContent = (state: ISharedContentState) => state.sharedContent;

export const getSharedContentActionState = (state: ISharedContentState) =>
  state.sharedContentActionState;

export const getUnread = (state: ISharedContentState) => state.unread;

export const getUnreadActionState = (state: ISharedContentState) => state.unreadActionState;
export const getMigrateDocumentsActionState = (state: ISharedContentState) =>
  state.migrateDocumentsActionState;
